import Product from '../views/product';
import ProductCreate from '../views/product/create'
import ProductDetail from '../views/product/detail';
import ProductEdit from '../views/product/edit';
import Error404 from '../views/error/Error404';
import Error500 from '../views/error/Error500';
import Supplier from '../views/supplier';
import SupplierCreate from '../views/supplier/create';
import SupplierEdit from '../views/supplier/edit';
import SupplierDetail from '../views/supplier/detail';
import PurchaseOrder from '../views/purchase-order';
import PurchaseOrderCreate from '../views/purchase-order/create';
import PurchaseOrderDetail from '../views/purchase-order/detail';
import Refund from '../views/refund';
import RefundCreate from '../views/refund/create';
import OrderCreate from '../views/orders/create';
import Customer from '../views/customer';
import CustomerCreate from '../views/customer/create';
import CustomerDetail from '../views/customer/detail';
import CustomerEdit from '../views/customer/edit';
import Orders from '../views/orders';
import OrderDetail from '../views/orders/detail';
import WarrantyCard from '../views/warranty-card';
import WarrantyClaimCard from '../views/warranty-claim-card';
import WarrantyClaimCardCreate from '../views/warranty-claim-card/create';
import CustomerRefund from '../views/customer-refund';
import CustomerRefundDetail from '../views/customer-refund/detail';
import CustomerRefundCreate from '../views/customer-refund/create';
import Revenue from '../views/dashboard/revenue';
import InventoryReport from '../views/dashboard/inventory-report';

export const routes = [
	{ path: '/product', component: Product, permission: ['ROLE_ADMIN', 'ROLE_SALES']  },
	{ path: '/product/create', component: ProductCreate, permission: ['ROLE_ADMIN', 'ROLE_SALES']  },
	{ path: '/product/:id', component: ProductDetail, permission: ['ROLE_ADMIN', 'ROLE_SALES']  },
	{ path: '/product/edit/:id', component: ProductEdit, permission: ['ROLE_ADMIN', 'ROLE_SALES']  },
	{ path: '/purchase-order', component: PurchaseOrder, permission: ['ROLE_ADMIN', 'ROLE_SALES'] },
	{ path: '/purchase-order/create', component: PurchaseOrderCreate, permission: ['ROLE_ADMIN', 'ROLE_SALES'] },
	{ path: '/purchase-order/:id', component: PurchaseOrderDetail, permission: ['ROLE_ADMIN', 'ROLE_SALES'] },
	{ path: '/supplier', component: Supplier, permission: ['ROLE_ADMIN', 'ROLE_SALES'] },
	{ path: '/supplier/create', component: SupplierCreate, permission: ['ROLE_ADMIN', 'ROLE_SALES'] },
	{ path: '/supplier/edit/:id', component: SupplierEdit, permission: ['ROLE_ADMIN', 'ROLE_SALES'] },
	{ path: '/supplier/:id', component: SupplierDetail, permission: ['ROLE_ADMIN', 'ROLE_SALES'] },
	{ path: '/refund', component: Refund, permission: ['ROLE_ADMIN', 'ROLE_SALES'] },
	{ path: '/refund/create', component: RefundCreate, permission: ['ROLE_ADMIN', 'ROLE_SALES'] },
	{ path: '/orders', component: Orders, permission: ['ROLE_ADMIN', 'ROLE_SALES', 'ROLE_TECHNIQUE'] },
	{ path: '/orders/:id', component: OrderDetail, permission: ['ROLE_ADMIN', 'ROLE_SALES', 'ROLE_TECHNIQUE'] },
	{ path: '/create-orders', component: OrderCreate, permission: ['ROLE_ADMIN', 'ROLE_SALES', 'ROLE_TECHNIQUE'] },
	{ path: '/customer', component: Customer, permission: ['ROLE_ADMIN', 'ROLE_SALES'] },
	{ path: '/customer/create', component: CustomerCreate, permission: ['ROLE_ADMIN', 'ROLE_SALES'] },
	{ path: '/customer/edit/:id', component: CustomerEdit, permission: ['ROLE_ADMIN', 'ROLE_SALES'] },
	{ path: '/customer/:id', component: CustomerDetail, permission: ['ROLE_ADMIN', 'ROLE_SALES'] },
	{ path: '/customer-refund', component: CustomerRefund, permission: ['ROLE_ADMIN', 'ROLE_SALES'] },
	{ path: '/customer-refund/create', component: CustomerRefundCreate, permission: ['ROLE_ADMIN', 'ROLE_SALES'] },
	{ path: '/customer-refund/:id', component: CustomerRefundDetail, permission: ['ROLE_ADMIN', 'ROLE_SALES'] },
	{ path: '/warranty-card', component: WarrantyCard, permission: ['ROLE_ADMIN', 'ROLE_TECHNIQUE']  },
	{ path: '/warranty-claim-card/:id', component: WarrantyClaimCard, permission: ['ROLE_ADMIN', 'ROLE_TECHNIQUE']  },
	{ path: '/warranty-claim-card/create/:id', component: WarrantyClaimCardCreate, permission: ['ROLE_ADMIN', 'ROLE_TECHNIQUE']  },
	{ path: '/revenue', component: Revenue, permission: ['ROLE_ADMIN']  },
	{ path: '/inventory-report', component: InventoryReport, permission: ['ROLE_ADMIN']  },
	{ path: '/error/404', component: Error404 },
	{ path: '/error/500', component: Error500 }
];
